import cx from 'classnames';
import { CheckIcon, CrossIcon } from '@wkda/icons';

export type OptionItem = { value: string | number | boolean; label: string };

export interface SelectProps extends React.ComponentPropsWithoutRef<'select'> {
  options: OptionItem[] | { [key: string]: OptionItem[] };
  className?: string;
  defaultOption?: React.ReactNode;
  value?: string | number;
  isValid?: boolean;
  showVisualFeedback?: boolean;
  mktSelector?: string;
  qaSelector?: string;
  placeholderOption?: string;
}

export default function Select({
  className,
  options,
  placeholderOption,
  value,
  isValid,
  showVisualFeedback = false,
  mktSelector,
  qaSelector,
  ...selectProps
}: SelectProps) {
  const status =
    typeof isValid === 'undefined'
      ? 'not-validated'
      : isValid === true
        ? 'valid'
        : 'invalid';
  const showPlaceholder = placeholderOption && !value;
  return (
    <div className="custom-select__container icon-select__container">
      <select
        {...selectProps}
        className={cx('custom-select', className, {
          'is-invalid': status === 'invalid',
        })}
        value={value}
        data-mkt-selector={mktSelector}
        data-qa-selector={qaSelector || mktSelector}
        data-qa-selector-value={value}
      >
        {placeholderOption && (
          <option value={''} disabled>
            {placeholderOption}
          </option>
        )}
        {Array.isArray(options)
          ? options.map(({ value, label }) => {
              const usableValue =
                typeof value === 'boolean' ? String(value) : value;
              return (
                <option
                  key={usableValue}
                  value={usableValue}
                  data-qa-selector-value={value}
                >
                  {label}
                </option>
              );
            })
          : Object.entries(options).map(([key, itemOptions]) => (
              <optgroup label={key} key={key}>
                {itemOptions.map(({ value, label }) => {
                  const usableValue =
                    typeof value === 'boolean' ? String(value) : value;
                  return (
                    <option key={usableValue} value={usableValue}>
                      {label}
                    </option>
                  );
                })}
              </optgroup>
            ))}
      </select>
      {showPlaceholder ? (
        <div className="custom-select__placeholder" aria-hidden={true}>
          {placeholderOption}
        </div>
      ) : null}
      {status === 'valid' && showVisualFeedback ? (
        <CheckIcon className="icon-select__icon text-success" />
      ) : null}
      {status === 'invalid' && showVisualFeedback ? (
        <CrossIcon className="icon-select__icon icon-select__icon-cross text-danger" />
      ) : null}
    </div>
  );
}
